<div
  class="flex text-R900 text-b2 font-sans gap-[8px] pt-[8px] animated fadeIn {{ extraClass }}"
>
  <img
    src="/assets/massimo/svg/fi_alert-triangle.svg"
    alt="fi_alert-triangle"
  />
  {{ message }}
</div>
